export const SET_SUPER_USER = 'SET_SUPER_USER';
export const SET_SUPER_USER_RETURN_ROUTE = 'SET_SUPER_USER_RETURN_ROUTE';
export const SET_SIGNED_IN_USER = 'SET_SIGNED_IN_USER';
export const SET_SELECTED_REGION = 'SET_SELECTED_REGION';
export const SET_REGIONS = 'SET_REGIONS';
export const SHOW_LOGIN = 'SHOW_LOGIN';
export const SHOW_SIGNUP = 'SHOW_SIGNUP';
export const SHOW_OPTION = 'SHOW_OPTION';
